import { Dialog } from './Dialog/Dialog';

/**
 * Wrapper for react-bootstrap Modal.
 * @see https://react-bootstrap.github.io/components.html#modals
 *
 * Potential code duplication: ReactModalDialog/ModalDialog/Dialog/BootstrapModal
 */
export const ModalDialog = Dialog;

/*
props = {
  title: String,
  show: PropTypes.bool,
  onHide: function(event),
  backdrop: PropTypes.oneOf(['static', true, false]),
  actions: [
    {
      label: String,
      onClick: function(event)
      type: String (primary, secondary, default) // styling
    }
  ],

  dialogClassName: PropTypes.string,
  children: content,
}
 */
